import React from "react";
import "../styles/footer.css";

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="footer-container">
        
        {/* Left Section */}
        <div className="footer-section">
          <h3>Udyog Connect</h3>
          <p>
            Supporting small enterprises through partnerships, manpower,
            technology services, and community-driven growth initiatives.
          </p>
        </div>

        {/* Contact Section */}
        <div className="footer-section">
          <h4>Contact Us</h4>
          <p>📧 info@udyogconnect.org</p>
          <p>📞 470-227-0979</p>
        </div>

        {/* Organization Info */}
        <div className="footer-section">
          <h4>Organization</h4>
          <p>Site Owner: Udyog Connect Corp.</p>
          <p>Website: Prodash Innovative Solutions</p>
        </div>
      </div>

      {/* Divider */}
      <div className="footer-divider" />

      {/* Bottom Section */}
      <div className="footer-bottom">
        <p>
          Udyog Connect Corp is a registered nonprofit organization in the United States and is recognized as a tax-exempt organization under Section <span className="footer-tax-status">501(c)(3)</span> of the Internal Revenue Code.
        </p>

        <p>
          The domain udyogconnect.org is officially owned, managed, and operated by Udyog Connect Corp.
        </p>

        <p className="copyright">
          © 2026 Udyog Connect. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
